module.exports = __webpack_public_path__ + "img/overview_front.e0ebfe99.png";